import { render, staticRenderFns } from "./campaign-setting-form.vue?vue&type=template&id=85c512a0"
import script from "./campaign-setting-form.vue?vue&type=script&lang=js"
export * from "./campaign-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports